export async function getPlatformVersion() {
  // const PKG = await import('@symbo.ls/platform/package.json')
  if (PKG) return PKG.version
}

export function getRootState(param) {
  let state = null
  const hasRootState = (obj) =>
    obj.__element &&
    obj.root?.isRootState
  if (!this) {
    state = window.platformState || window.smblsApp?.state
  } else if (hasRootState(this)) {
    state = this.root
  } else if (this.__ref && this.__ref.path) {
    const hasPlatformState = this.state && hasRootState(this.state)
    const hasPlatformStateOnParent =
      this.call('isFunction', this.state) &&
      this.parent.state &&
      hasRootState(this.parent.state)
    if (hasPlatformState || hasPlatformStateOnParent) {
      state = this.state.root || this.parent.state.root
    }
  }
  if (!state) {
    state = window.platformState || window.smblsApp?.state
  }
  return param ? state?.[param] : state
}

export function getRef(key) {
  if (key) {
    return this.__ref && this.__ref[key]
  }
  return this.__ref
}

export function getChildren() {
  const __children = this.getRef('__children')
  return __children?.map((k) => this[k])
}

export function getRoot(key) {
  const rootElem = this.getRootState()?.__element
  return rootElem && Object.keys(rootElem).length > 0 && key
    ? rootElem[key]
    : rootElem
}

export function getRootData(key) {
  return this.getRoot('data') &&
    Object.keys(this.getRoot('data')).length > 0 &&
    key
    ? this.getRoot('data')[key]
    : this.getRoot('data')
}

export function getRootContext(key) {
  const ctx = this.getRoot()?.context
  return key ? ctx?.[key] : ctx
}

export function getContext(key) {
  const ctx = this.context
  return key ? ctx[key] : ctx
}

export function getAppKey() {
  return this.getRootState()?.appKey
}

export function isPlatform() {
  return (
    this.getRootState('projectType') === 'platform' ||
    [
      'brand.symbo.ls',
      'smbls.symbo.ls',
      'platform.symbo.ls',
      'docs.symbo.ls',
      'assistant.symbo.ls',
      'landing.symbo.ls',
      'pricing.symbo.ls'
    ].includes(this.getAppKey())
  )
}

export function getSchema(key) {
  const { schema } = this.getRootState() || {}
  return key ? schema?.[key] : schema
}

export function getData(key) {
  const rootState = this.getRootState() || this.state?.root || {}
  const source = rootState.data || rootState
  const {
    designSystem,
    state,
    components,
    snippets,
    pages,
    functions,
    methods,
    files,
    dependencies
  } = source
  const data = {
    designSystem,
    state,
    components,
    snippets,
    pages,
    functions,
    methods,
    files,
    dependencies
  }
  return key ? data[key] : data
}

export function getMySharedLibraries() {
  const root = this.getRootState && this.getRootState()
  return (root && root.sharedLibraries) || []
}

export async function getDefaultDesignSystem() {
  return {} // await import('@symbo.ls/library/default/designSystem')
}

export async function getDefaultComponents() {
  return {} // await import('@symbo.ls/library/default/components')
}

export async function getDefaultComponentsSchema() {
  const { DEFAULT_COMPONENTS_SCHEMA } = {} // await import('@symbo.ls/library/default.js')
  return DEFAULT_COMPONENTS_SCHEMA
}

export async function getDefaultLibrary() {
  const { LIBRARY } = {} // await import('@symbo.ls/library/default.js')
  return LIBRARY
}

export async function getDefaultData(key) {
  const data = {
    designSystem: await this.getDefaultDesignSystem(),
    components: await this.getDefaultComponents()
  }
  return key ? data[key] : data
}

export function getDefaults(key) {
  const defs = this.getRootState('DEFAULTS')
  return defs?.[key] || defs
}

export function getBuiltins() {
  const defs = this.getRootState('DEFAULTS')
  return defs?.DS_DEFAULTS
}

export function getSecrets(key) {
  const secrets = this.getRootState('secrets')
  return key ? secrets?.[key] : secrets
}

export function getDependencies(key) {
  const dependencies = this.getData('dependencies')
  return key ? dependencies?.[key] : dependencies
}

export function getFiles(key) {
  const files = this.getData('files')
  return key ? files?.[key] : files
}

export function getComponents(key) {
  const components = this.getData('components')
  return key ? components?.[key] : components
}

export function getFunctions(key) {
  const functions = this.getData('functions')
  return key ? functions?.[key] : functions
}

export function getState(key) {
  const state = this.getData('state')
  return key ? state?.[key] : state
}

export function getMethods(key) {
  const methods = this.getData('methods')
  return key ? methods?.[key] : methods
}

export function getActivePkgManager() {
  return this.getRootState('pkgManager')
}

export function getPackages(key) {
  const packages = this.getSchema('dependencies')
  return key && packages ? packages[key] : packages || {}
}

export function getParsedState(obj = this) {
  const isState2 = this.isState(obj)
  if (isState2) {
    return obj.parse()
  }

  const hasState = this.isState(obj.state)
  if (hasState) {
    return obj.state.parse()
  }

  return (obj.parseDeep && obj.parseDeep()) || obj
}

export function getUtils() {
  return this.context.utils
}

export function getUtil(key) {
  return this.getUtils()[key]
}

export function getUserSettings(key) {
  const userSettings = this.getRootState('user')
  return key ? userSettings?.[key] : userSettings
}

export function setUserSettings(key, val, opts) {
  const autoSaveSettings = false //this.getUserSettings('autoSaveSettings')
  this.getRootState().update(
    {
      user: { [key]: val }
    },
    autoSaveSettings ? opts : { ...opts, preventUpdate: true }
  )
  // console.log(key, val, opts)
  this.call('setCookie', key, val)
}

export function toggleUserSettings(key, opts) {
  const val = !this.getUserSettings(key)
  this.setUserSettings(key, val, opts)
}

export function setAllUserSettings(obj, opts) {
  // console.log(obj)
  this.getRootState().update({ user: obj }, opts)
  // eslint-disable-next-line guard-for-in
  for (const prop in obj) {
    this.call('setCookie', prop, this.getUserSettings(prop))
  }
}

export function isState(obj) {
  if (!this.call('isObjectLike', obj)) {
    return false
  }
  return (
    obj.update &&
    obj.parse &&
    obj.clean &&
    obj.create &&
    obj.parent &&
    obj.destroy &&
    obj.rootUpdate &&
    obj.parentUpdate &&
    obj.keys &&
    obj.values &&
    obj.toggle &&
    obj.replace &&
    obj.quietUpdate &&
    obj.quietReplace &&
    obj.add &&
    obj.apply &&
    obj.applyReplace &&
    obj.applyFunction &&
    obj.__element &&
    obj.__children
  )
  // return arrayContainsOtherArray(keys, ['update', 'parse', 'clean', 'create', 'parent', 'rootUpdate'])
}

export function addToPlatformContext(type, key) {
  const context = this.context
  const item = this.getDataItem(key, type)
  context[type][key] = this.call('deepClone', item)
}

export function addIfPlatformProject(type, key) {
  if (this.isPlatform()) this.addToPlatformContext(type, key)
}

export function getGlobalTheme() {
  const platformState = this.getRootState()
  if (!platformState) return 'dark'
  const { designSystem } = platformState
  return platformState.sceneTheme || designSystem?.globalTheme
}
